import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";
import { type IDocument, type IDocumentWithInfo, type ILawdocsSavePayload } from "@types";

export const USER_DOCUMENTS_API_REDUCER_KEY = "userDocumentsApi";
export const userDocumentsApi = createApi({
  reducerPath: USER_DOCUMENTS_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      isExternalService: true,
      ...extraOptions,
    }),
  tagTypes: ["USER_DOCUMENTS"],
  endpoints: (builder) => ({
    getUserDocuments: builder.query<IDocumentWithInfo[], void>({
      query: () => ({
        url: "/documents",
        method: "GET",
      }),
      providesTags: ["USER_DOCUMENTS"],
    }),
    postUserDocument: builder.mutation<
      { document_id: IDocument["id"]; document_identifier: string },
      ILawdocsSavePayload & { magicToken: string }
    >({
      query: ({ magicToken, ...body }) => ({
        url: "/documents",
        method: "POST",
        body,
        headers: { [httpHeaders.magicToken]: magicToken },
      }),
      extraOptions: { isExternalService: false, isUnauthorizedLogoutEnabled: false },
    }),
  }),
});

export const { useGetUserDocumentsQuery, useLazyGetUserDocumentsQuery, usePostUserDocumentMutation } = userDocumentsApi;
